import { inject, Injectable } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { from, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  
  // Skip interceptor for authentication endpoints (user registration/login, not workforce registration)
  const authEndpoints = ['/login', '/sign-in', '/auth/', '/forgot-password', '/reset-password'];
  // Also skip for user registration endpoints (but NOT workforce/vendor registration)
  const userRegisterEndpoints = ['/user/register', '/customer/register', '/vendor/register'];
  const isAuthEndpoint = authEndpoints.some(endpoint => req.url.includes(endpoint)) ||
    userRegisterEndpoints.some(endpoint => req.url.includes(endpoint));
  
  // Skip interceptor if the request already has Authorization header (e.g., login requests) or is an auth endpoint
  if (req.headers.has('Authorization') || isAuthEndpoint) {
    console.log('Skipping interceptor for auth endpoint or request with Authorization header');
    return next(req);
  }
  
  return from(Promise.all([authService.getToken(), authService.getDeviceId(), authService.getDevicetype()])).pipe(
    switchMap(([token, deviceId, deviceType]) => {
      console.log('Auth interceptor - User token:', token ? 'exists' : 'null');
      if (token && token !== 'null' && token !== 'undefined') {
        const cloned = req.clone({
          setHeaders: {
            'Authorization': `Bearer ${token}`,
            'X-Auth-Type': 'AUTH',
            'X-App-Type': 'LUNA_ADMIN',
            'X-Device-Id': deviceId,
            'X-Device-Type': deviceType
          },
        });
        return next(cloned).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401 || (error.error?.error && error.error.error.includes('JWT token is expired'))) {
              console.error('JWT Token expired or unauthorized, redirecting to login');
              // Clear all stored authentication data
              authService.signOut();
              localStorage.clear();
              sessionStorage.clear();
              // Redirect to sign-in with expired session message
              router.navigate(['/sign-in'], { queryParams: { reason: 'expired' } });
            }
            return throwError(() => error);
          })
        );
      }
      // No user token, pass through without modification
      console.log('No user token, request passed through');
      return next(req);
    })
  );
};